import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const API_BASE_URL = "http://api-staging.vehiclewip.com";

const STORE_LOGIN_URL = `${API_BASE_URL}/login`;
const STORE_FORGOT_PASSWORD = `${API_BASE_URL}/forgot-password`;
const STORE_REFRESH_TOKENS = `${API_BASE_URL}/authentication`;
const LOGOUT = `${API_BASE_URL}/logout`;

const SEND_EMAIL_2FA_URL = `${API_BASE_URL}/send-email-2fa`;

var platform = require("platform");
console.log("platform--->", platform.description);
const publicIp = require("public-ip");
var ipv4 = (async () => {
  ipv4 = await publicIp.v4();

  //console.log("publicIp.v4 -->", await publicIp.v4());
  //=> '46.5.21.123'

  // console.log("publicIp.v6 -->", await publicIp.v6());
  //=> 'fe80::200:f8ff:fe21:67cf'
})();

/**
 * Login api
 * @param {Object} param
 * @param {String} param.email user email
 * @param {String} param.password user password
 * @returns {Object} userData
 */
export const loginRequest = async ({ email, password, userCode2FA }) => {
  console.log("common js line 34", userCode2FA);
  try {
    // const response = await axios.post(STORE_LOGIN_URL, { email, password });
    const response = await axios({
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      url: STORE_LOGIN_URL,
      data: { email, password, code_2fa: userCode2FA },
    });

    console.log("response --->", response);

    if (response.status === 200 || response.status === 400) {
      //console.log("response status --->", response.status);
      return response.data;
    } else {
      console.log("response in else --->", response);
      return null;
    }
  } catch (error) {
    if (error.response) {
      console.log("error.response --->", error.response);
      return error.response.data;
    }
    console.log("Error in loginRequest", error, error.response);
    return null;
  }
};

export const forgotPasswordRequest = async ({ email }) => {
  //const response = await axios.post(STORE_FORGOT_PASSWORD, { email });

  const response = await axios({
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    url: STORE_FORGOT_PASSWORD,
    data: { email },
  });

  if (response.status === 200 || response.status === 400) {
    return response.data;
  } else {
    return null;
  }
};

export const refreshTokenRequest = async ({ refreshToken }) => {
  // const response = await axios.post(STORE_REFRESH_TOKENS, {
  //   auth: refreshToken,
  // });
  // return response;
  const response = await axios({
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    url: STORE_REFRESH_TOKENS, //authentication
    data: { auth: refreshToken },
  });
  return response;
};

export const logout = async ({ authToken }) => {
  console.log("Logout response.data authToken --->", authToken);
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
    },
    url: LOGOUT,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  console.log("Logout response.data api --->", response.data);
  return response.data;
};

export const send2FAEmail = async ({ email }) => {
  try {
    const response = await axios({
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      url: SEND_EMAIL_2FA_URL,
      data: { email, platform: platform.description, ip4: ipv4 },
    });

    console.log("response --->", response);

    if (response.status === 200 || response.status === 400) {
      //console.log("response status --->", response.status);
      return response.data;
    } else {
      console.log("response in else --->", response);
      return null;
    }
  } catch (error) {
    if (error.response) {
      console.log("error.response --->", error.response);
      return error.response.data;
    }
    console.log("Error in send2FAEmail", error, error.response);
    return null;
  }
};
